import type { State } from '../reducer.tsx';

// @deprecated baseUrl is always '', remove it from your packages: go/baseurl-cleanup-jfe
export const getBaseUrl = (_state: State) => '';
export const isAdmin = (state: State) => state.context.isAdmin;
export const getLocale = (state: State) => state.context.locale;
